    import React from 'react'
    import { Link } from 'react-router-dom'
    import blogList from './BlogData'

    export default function CardBlogs(props) {

        const { noofblogs } = props || '3';
        const allBlogs = [...blogList].sort((a, b) => new Date(b.displaydate) - new Date(a.displaydate)).slice(0, 3);

        return (
            <>        
            <div className="row g-0 py-2 py-md-4 card-blogs-title">
                <div className='text-center head-service-text'>
                    Explore our Expertise
                </div>
            </div>
                <div className="row row-cols-1 row-cols-md-3 g-0 my-0 blog-container-wrap">
                {allBlogs.slice(0, noofblogs).map((blog, index) => (
                    <div className="col"  key={`articles-main-${index}`} >
                        <div className="card h-100 shadow-drop-center">
                            <Link to={"/blog/"+blog.title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()} className="no-link-default-style">
                                <img src={blog.imageUrlPath} className="card-img-top" alt={blog.title} />
                            </Link>
                            <div className="card-body">
                                <p className="card-text"><span>{blog.displaydate.toDateString()}</span> | <span>{blog.author}</span></p>
                                <Link to={"/blog/"+blog.title.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()} className="no-link-default-style">
                                    <h5 className="card-title">{blog.title}</h5>
                                </Link>
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
            </>
        )
    };
